import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatNativeDateModule, MatRippleModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule, MatIconRegistry } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { TextMaskModule } from "angular2-text-mask";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSliderModule } from "@angular/material/slider";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { IconService } from "./services/icon-services";
import { DomSanitizer } from "@angular/platform-browser";
import { TranslateModule } from "@ngx-translate/core";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxCurrencyModule } from "ngx-currency";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { QuillModule } from "ngx-quill";
import { FlagComponent } from "../pages/login/flag/flag.component";
import { FeatherModule } from "angular-feather";
import { allIcons } from "angular-feather/icons";
import { NgxPermissionsModule } from "ngx-permissions";
import { AddButtonComponent } from "./add-button/add-button.component";
import { ActionButtonsComponent } from "./action-buttons/action-buttons.component";
import { DownloadComponent } from "./components/download/download.component";
import { SafeHtmlPipe } from "./components/safe-html.pipe";
import { DualMultiSelectComponent } from "./dual-multi-select/dual-multi-select.component";
import { MatTreeModule } from "@angular/material/tree";
import { ScrollToModule } from "@nicky-lenaers/ngx-scroll-to";
import { TplmisTreeComponent } from "./tplmis-tree/tplmis-tree.component";
import { TreeModule } from "@circlon/angular-tree-component";
import { MatBadgeModule } from "@angular/material/badge";
import { SearchDialogComponent } from "../pages/users/user-management/Forms/search-dialog.component";
import { ChangePasswordComponent } from "../pages/dashboard/change-password/change-password.component";
import { HighchartsChartModule } from "highcharts-angular";
import { SearchPipe } from "src/app/shared/search-pipe";

import { GroupRegistrationComponent } from "../pages/applications/group-registration/group-registration.component";
import { GroupStatusComponent } from "../pages/applications/group-status/group-status.component";
import { GroupInformationComponent } from "../pages/group/group-information/group-information.component";
import { EconomicActivitiesComponent } from "../pages/applications/economic-activities/economic-activities.component";
import { GroupMembersComponent } from "../pages/applications/group-members/group-members.component";
import { GroupLeadersComponent } from "../pages/applications/group-leaders/group-leaders.component";
import { ApplicationStatusComponent } from "../pages/group/application-status/application-status.component";
import { GroupAttachmentsComponent } from "../pages/applications/group-attachments/group-attachments.component";
import { SubmitApplicationComponent } from "../pages/applications/submit-application/submit-application.component";
import { DcdoViewComponent } from "../pages/dcdo/dcdo-view/dcdo-view.component";
import { DedViewComponent } from "../pages/ded/ded-view/ded-view.component";
import { LanguageComponent } from "../pages/landing/language/language.component";
import { ReportTreeComponent } from "./report-tree/report-tree.component";
import { AutocompleteComponent } from "./autocomplete/autocomplete.component";
import { MatInputCommifiedDirective } from "../shared/mat-input-commified.directive";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";

import {
  PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface,
} from "ngx-perfect-scrollbar";
import { AreaTreeComponent } from "./area-tree/area-tree.component";
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};
@NgModule({
  imports: [
    FormsModule,

    NgxCurrencyModule,
    ReactiveFormsModule,
    NgbModule,
    CommonModule,
    FlexLayoutModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    MatBadgeModule,
    TextMaskModule,
    MatTreeModule,
    FeatherModule.pick(allIcons),
    ScrollToModule,
    TreeModule,
    HighchartsChartModule,
    PerfectScrollbarModule,
    NgxExtendedPdfViewerModule,
  ],
  exports: [
    FormsModule,

    ScrollToModule,
    NgxPermissionsModule,
    NgxCurrencyModule,
    TranslateModule,
    ReactiveFormsModule,
    NgbModule,
    FlexLayoutModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatBadgeModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    MatTreeModule,
    FlagComponent,
    AddButtonComponent,
    ActionButtonsComponent,
    TextMaskModule,
    FeatherModule,
    DownloadComponent,
    SafeHtmlPipe,
    DualMultiSelectComponent,
    TplmisTreeComponent,
    SearchDialogComponent,
    ChangePasswordComponent,
    GroupInformationComponent,
    EconomicActivitiesComponent,
    HighchartsChartModule,
    GroupMembersComponent,
    GroupLeadersComponent,
    ApplicationStatusComponent,
    GroupAttachmentsComponent,
    SubmitApplicationComponent,
    DcdoViewComponent,
    LanguageComponent,
    SearchPipe,
    ReportTreeComponent,
    AutocompleteComponent,
    MatInputCommifiedDirective,
    NgxExtendedPdfViewerModule,
    AreaTreeComponent,
  ],
  declarations: [
    FlagComponent,
    AddButtonComponent,
    ActionButtonsComponent,
    DownloadComponent,
    SafeHtmlPipe,
    DualMultiSelectComponent,
    TplmisTreeComponent,
    SearchDialogComponent,
    ChangePasswordComponent,
    SearchPipe,
    GroupInformationComponent,
    EconomicActivitiesComponent,
    GroupMembersComponent,
    GroupLeadersComponent,
    ApplicationStatusComponent,
    GroupAttachmentsComponent,
    SubmitApplicationComponent,
    DedViewComponent,
    LanguageComponent,
    DcdoViewComponent,
    ReportTreeComponent,
    AutocompleteComponent,
    MatInputCommifiedDirective,
    AreaTreeComponent,
  ],
  entryComponents: [
    DownloadComponent,
    GroupInformationComponent,
    EconomicActivitiesComponent,
    GroupMembersComponent,
    GroupLeadersComponent,
    ApplicationStatusComponent,
    GroupAttachmentsComponent,
    SubmitApplicationComponent,
    DedViewComponent,
    DcdoViewComponent,
    SafeHtmlPipe,
    SearchPipe,
    LanguageComponent,
  ],

  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
})
export class SharedModule {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private svgIconService: IconService,
    private domSanitizer: DomSanitizer
  ) {
    for (let i = 0; i < this.svgIconService.customerIcons.length; i++) {
      this.matIconRegistry.addSvgIconLiteral(
        this.svgIconService.customerIcons[i].name,
        this.domSanitizer.bypassSecurityTrustHtml(
          this.svgIconService.customerIcons[i].tag
        )
      );
    }
  }
}
